const baseUrl = "/finance-web";
import http from "./http";

// 获取可选择的项目部
const getDeptList = () => {
  return http.get("/contract-web/project/queryAllProjectDept");
};

// 根据项目部ID查项目列表
// 新建付款明细时用这个
const getProjectList = (params) => {
  return http.get("/contract-web/project/queryProjectListByDeptId", params);
};

//根据项目ID查总包合同数据(外部模块使用)
/**
 * amount: 10000//总金额
belongYear: "2020"//项目所属年份
deptName: "测试部门"
id: 77
liabilityPeriod: "1111"// 缺陷责任期
partyA: "111"//甲方名称（欠款单位）
projectName: "111111"
projectTime: "11"//合同工期
provisionalAmount: 100//暂定金金额
signDate: "2020-11-30" //合同签订日期
 * @param {*} params 
 * @returns 
 */
const getProjectContractData = (params) => {
  return http.get("/contract-web/project/queryContractByProjectId", params);
};

/**
 * 获取付款明细列表
 * @param {*} params
 * @returns
 */
const getPaymentList = (params) => {
  return http.get(baseUrl + "/payDetail/list", params, false);
};

/**
 * 获取付款明细详情
 * @param {*} params
 * @returns
 */
const getPaymentDetail = (params) => {
  return http.get(baseUrl + "/payDetail", params);
};

/**
 * 编辑付款明细
 * @param {*} params
 * @returns
 */
const editPaymentDetail = (params) => {
  return http.put(baseUrl + "/payDetail", params);
};

/**
 * 删除付款明细条目
 * @param {*} params
 * @returns
 */
const deletePayment = (params) => {
  return http.delete(baseUrl + "/payDetail", params, false);
};

/**
 * 创建新的付款明细
 * @param {*} params
 * @returns
 */
const addPayment = (params) => {
  return http.post(baseUrl + "/payDetail", params);
};

// 获取审计及竣工情况的选项
const getProcessStatusList = () => {
  // {"id":98,"dictId":35,"pid":0,"label":"ysj","value":"已审计","sort":1,"subDictMap":null}
  return http.get(baseUrl + "/receipts/process/dict/list", null, false);
};

// 查询收款列表
const getCollectionList = (params) => {
  return http.get(baseUrl + "/receipts/list", params, false);
};

/**
 * 新建收款记录
 * @param {*} params
 * @returns
 */
const createCollectionItem = (params) => {
  return http.post(baseUrl + "/receipts", params);
};

/**
 * 编辑收款记录
 * @param {*} params
 * @returns
 */
const editCollectionItem = (params) => {
  return http.put(baseUrl + "/receipts", params);
};

// 收款列表里查看某条对应的修改日志，日志是翻页的
const getCollectionItemLog = (params) => {
  return http.get(baseUrl + "/receipts/log", params, false);
};

// 收款记录的详情
const getCollectionDetail = (params) => {
  return http.get(baseUrl + "/receipts/detail", params, false);
};

// 收款记录的历史详情
const getCollectionHistoryDetail = (params) => {
  return http.get(baseUrl + "/receipts/detail/history", params, false);
};

//查询收入成本列表
const getEarningConstList = (params) => {
  return http.get(baseUrl + "/earningCost/list", params);
};

// 查询收入成本操作记录
const getIncomingConstItemLog = (params) => {
  return http.get(baseUrl + "/earningCost/operateRecord/list", params);
};

//----  收入成本详情查看的接口------
/**
 * 查询收入成本确认表
 * @param {*} params
 * @returns
 */
const queryEarningCostCheckTable = (params) => {
  return http.get(baseUrl + "/earningCost/queryEarningCostCheckTable", params);
};

/**
 * 查询收入成本汇总表
 * @param {*} params
 * @returns
 */
const queryEarningCostGatherTable = (params) => {
  return http.get(baseUrl + "/earningCost/queryEarningCostGatherTable", params);
};

/**
 * 查询收支明细表
 * @param {*} params
 * @returns
 */
const queryEarningCostDetailTable = (params) => {
  return http.get(baseUrl + "/earningCost/queryEarningCostDetailTable", params);
};

/**
 * 工程成本明细表
 * @param {*} params
 * @returns
 */
const queryProjectCostDetailTable = (params) => {
  return http.get(baseUrl + "/earningCost/queryProjectCostDetailTable", params);
};

/**
 * 收入记录的基本数据
 * @param {*} params
 * @returns
 */
const earningCost = (params) => {
  return http.get(baseUrl + "/earningCost", params);
};

/**
 * 查询收入成本详情
 * @param {*} params
 * @returns
 */
const getReceiptsEarningCost = (params) => {
  return http.get(baseUrl + "/receipts/detail/earningCost", params);
};

/**
 * 查询收款属性详情
 * @param {*} params
 * @returns
 */
const getReceiptsDetailProperties = (params) => {
  return http.get(baseUrl + "/receipts/detail/properties", params);
};

/**
 * 根据项目id获取分包信息(外部模块使用)
 * fix:154 收入列表新建，劳务费编辑弹出窗口，合作单位出现多条重复数据
 * @param {*} params
 * @returns
 */
const getSubInfoByProjectId = (params) => {
  return http.get(
    "/contract-web/sub/contract/queryPartyBInfoByProjectId",
    params
  );
};

/**
 * 创建新的收入成本
 * @param {*} params
 * @returns
 */
const addEarningCost = (params) => {
  return http.post(baseUrl + "/earningCost", params);
};

const editEarningCost = (params) => {
  return http.put(baseUrl + "/earningCost", params);
};

/**
 * 项目部下拉列表
 * @param {*} params
 * @returns
 */
const getPayDetailListDept = (params) => {
  return http.get(baseUrl + "/payDetail/list/dept", params);
};
/**
 * 付款明细-自动带出付款信息
 * @param {*} params
 * @returns
 */
const queryEarningCostInfo = (params) => {
  return http.get(baseUrl + "/payDetail/queryEarningCostInfo", params);
};

/**
 * 查询工程款支付类型的会议提报列表
 * @param {*} params
 * @returns
 */
const getProjectPayList = (params) => {
  return http.get("conference-web/declaration/list/projectPay", params);
};
/**
 * 会议提报使用，付款申请页面信息
 * @param {*} params
 * @returns
 */
const queryPayRequestInfoApi = (params) => {
  return http.get(baseUrl + "/earningCost/queryPayRequestInfo", params);
};

/**
 * 查询所有新建过收入成本的项目部-新建付款申请使用
 * @param {*} params
 * @returns
 */
const earningCostqueryDeptListApi = (params) => {
  return http.get(baseUrl + "/earningCost/queryDeptList", params);
};

/**
 * 查询项目部下的项目-新建付款申请使用
 * @param {*} params
 * @returns
 */
const earningCostqueryProjectListAPi = (params) => {
  return http.get(baseUrl + "/earningCost/queryProjectList", params);
};

/**
 * 导出付款明细
 * @param {*} params
 * @returns
 */
const payDetailExportApi = (params) => {
  return http.get(baseUrl + "/payDetail/export", params);
};

/**
 * 导出收款
 * @param {*} params
 * @returns
 */
const receiptsExportApi = (params) => {
  return http.get(baseUrl + "/receipts/export", params);
};

/**
 * 导出收入成本
 * @param {*} params
 * @returns
 */
const earningCostExportapi = (params) => {
  return http.get(baseUrl + "/earningCost/export", params);
};

/**
 * 付款明细，查看列表，选定项目部之后，获取项目列表
 * @param {*} params
 * @returns
 */
const payDetailListProjectApi = (params) => {
  return http.get(baseUrl + "/payDetail/list/project", params);
};

/**
 * 根据乙方id获取分项合同列表
 * 用在收入列表新建和编辑时，费用的添加和编辑弹出框里，选定的合同单位变了，要调用接口获取合同内容
 * @param {*} params
 * @returns
 */
const querySubInfoByPartyBIdApi = (params) => {
  return http.get(
    "/contract-web/sub/contract/querySubInfoByPartyBIdProjectId",
    params
  );
};

const getDefaultDetailsApi = (params) => {
  return http.get(
    "/contract-web/project/middle/earningCost/getDefaultDetails",
    params
  );
};

const recallFinanceApi = (reqParam) => {
  return new Promise((resolve, reject) => {
    http
      .post("common-web/approve/recall", reqParam, false)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const queryApproveProcessApi = (reqParam) => {
  return new Promise((resolve, reject) => {
    http
      .get("common-web/approve/queryCurrentApproveProcess", reqParam, false)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const queryApproveHistoryApi = (params) => {
  return new Promise((resolve, reject) => {
    http
      .get("common-web/approve/queryApproveProcess", params, true)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

// 提交审批信息
const submitApproveProcessApi = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post("common-web/approve/submitApproveProcess", params, false)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

/**
 * 创建审批流
 * */
const createApproveProcessServiceApi = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post("common-web/approve/createApproveProcess", params, false)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

/**
 * 
收入成本-获取收支明细表的直接成本
 * @param {*} params 
 * @returns 
 */
const getEarningCostDirectCostApi = (params) => {
  return new Promise((resolve, reject) => {
    http
      .get("contract-web/project/middle/earningCost/getEarningCostDirectCost", params, true)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}


export {
  getProjectContractData,
  getDeptList,
  getProjectList,
  getPaymentList,
  deletePayment,
  getProcessStatusList,
  getCollectionList,
  getCollectionItemLog,
  getCollectionDetail,
  getEarningConstList,
  getIncomingConstItemLog,
  queryEarningCostCheckTable,
  queryEarningCostGatherTable,
  queryEarningCostDetailTable,
  queryProjectCostDetailTable,
  earningCost,
  getReceiptsEarningCost,
  getReceiptsDetailProperties,
  getSubInfoByProjectId,
  addEarningCost,
  editEarningCost,
  createCollectionItem,
  editCollectionItem,
  getPayDetailListDept,
  queryEarningCostInfo,
  getPaymentDetail,
  addPayment,
  editPaymentDetail,
  getProjectPayList,
  queryPayRequestInfoApi,
  earningCostqueryDeptListApi,
  earningCostqueryProjectListAPi,
  payDetailExportApi,
  receiptsExportApi,
  earningCostExportapi,
  getCollectionHistoryDetail,
  payDetailListProjectApi,
  querySubInfoByPartyBIdApi,
  getDefaultDetailsApi,
  recallFinanceApi,
  queryApproveProcessApi,
  queryApproveHistoryApi,
  submitApproveProcessApi,
  createApproveProcessServiceApi,
  getEarningCostDirectCostApi
};
